module.exports = __webpack_public_path__ + "media/images/patterns/congruent_pentagon-36f8acab53fe37dafbe181ddc560d280.png";